<!-- 商品管理 V2 - 提出订单默认售卖方案校验 -->
<template>
  <el-dialog
    :title="$t('message.productV2RaiseOrderPrompt')"
    :visible.sync="visible"
    width="560px"
    append-to-body
    custom-class="raise-order-dialog"
  >
    <p class="raise-order-warning">{{ $t('message.productV2RaiseOrderWarning') }}</p>
    <div v-for="item in missingList" :key="item.sys_code" class="missing-plan-row">
      <span>{{ item.client_sku_code }}</span>
      <el-button type="success" size="small" @click="$emit('maintain', item)">{{ $t('message.productV2PlanMaintain') }}</el-button>
    </div>
    <span slot="footer">
      <el-button type="primary" @click.native.prevent.stop="confirm">{{ $t('message.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'RaiseOrderDialog',
  data() {
    return { visible: false, list: [], missingList: [] }
  },
  methods: {
    confirm() {
      const list = this.list.slice()
      this.visible = false
      this.missingList = []
      this.$emit('ready', list)
    },
    open(list) {
      this.list = list.slice()
      this.missingList = list.filter(item => !item.order_plans.some(plan => plan.is_default == 1))
      if (this.missingList.length) {
        this.visible = true
        return
      }
      this.$emit('ready', list)
    }
  }
}
</script>

<style lang="scss">
.raise-order-dialog {
  .el-dialog__body { padding: 22px 28px 8px; }
  .raise-order-warning { margin: 0 0 14px; color: #f5222d; font-weight: 700; line-height: 20px; }
  .missing-plan-row { display: flex; align-items: center; justify-content: space-between; gap: 20px; margin-bottom: 10px; }
  .missing-plan-row span { min-width: 0; overflow-wrap: anywhere; }
}
</style>
